"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageExtension = exports.IMAGE_EXTENSIONS = void 0;
exports.IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "jfif"];
function isImageExtension(extension) {
    const normalizedExt = extension.startsWith(".") ? extension.slice(1) : extension;
    return exports.IMAGE_EXTENSIONS.includes(normalizedExt.toLowerCase());
}
exports.isImageExtension = isImageExtension;
//# sourceMappingURL=file-extension-utils.js.map